/*
 * MDB shim for Card
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/Settings/addDeliveryAcknowledgement.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Settings/productMatrixEntry.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 * - src/Seating/Users/userList.jsx
 */

import MUICard from "@mui/material/Card";

export default function Card({ children, className, style, ...rest }) {
    return (
        <MUICard className={className} style={style} {...rest}>
            {children}
        </MUICard>
    );
}
